module.exports = {
          srcSet: __webpack_public_path__ + "d3010a8e9ccfd60b59a653bd7915741c-66.jpg"+" 66w",
          images:[ {path: __webpack_public_path__ + "d3010a8e9ccfd60b59a653bd7915741c-66.jpg",width: 66,height: 34}],
          src: __webpack_public_path__ + "d3010a8e9ccfd60b59a653bd7915741c-66.jpg",
          toString:function(){return __webpack_public_path__ + "d3010a8e9ccfd60b59a653bd7915741c-66.jpg"},
          
          width: 66,
          height: 34
        }